<ng-container *ngFor="let items of determinantItems; let i=index;">
    <div class="position-relative isolate">
        <span class="determinant-element-row d-flex flex-shrink-1 mr-2 item-and-or and-or-separator my-2" *ngIf="i > 0">{{determinantItems[i].type}}</span>
    </div>
    <div class="d-flex align-items-baseline determinant-element-container px-3 py-2 flex-column {{hasError ? 'border border-danger' : ''}}">
        <div  class="determinant-element-item d-flex align-items-center" *ngFor="let item of items.conditions; let j=index;">
            <span class="d-flex flex-shrink-1 mr-2 item-and-or" *ngIf="j > 0">{{item.type}}</span>
            <div class="determinant-element-row d-flex flex-grow-1">
                <span class="strong">{{this.determinantMapById  && this.determinantMapById[item.determinantId] || findDeterminantName(item) }} </span>
            </div>
        </div>
    </div>
</ng-container>
